import { render, staticRenderFns } from "./StGallen.vue?vue&type=template&id=463fb1fa"
import script from "./StGallen.vue?vue&type=script&lang=js"
export * from "./StGallen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports